import { render, staticRenderFns } from "./liveStockTake.vue?vue&type=template&id=23bfb128&"
import script from "./liveStockTake.vue?vue&type=script&lang=js&"
export * from "./liveStockTake.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports